export { default as ReactTooltipSelectComponent } from './tooltip-select.component'
